import script from "./QRPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRPage.vue?vue&type=script&setup=true&lang=ts"

import "./QRPage.vue?vue&type=style&index=0&id=ec60e4d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec60e4d6"]])

export default __exports__